import React, { useState, useEffect } from 'react';
import { MapPin, Phone, Mail, Clock, Globe, ChevronRight, ExternalLink } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import contact from '../assets/contact.jpg'
const ContactUs = () => {
  const [scrolled, setScrolled] = useState(false);
  
  // Handle scroll effect for navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  return (
    <>
      <Header />
      
      <div className="flex flex-col min-h-screen bg-gray-50">
        {/* Page Header */}
        <section className="pt-24 pb-16 md:pt-32 md:pb-24 bg-gradient-to-r from-gray-900 to-gray-800 text-white">
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row items-center">
              <div className="md:w-1/2 mb-10 md:mb-0">
                <h1 className="text-4xl md:text-5xl font-bold mb-6">
                  Contact <span className="text-yellow-400">PVG Import Export</span>
                </h1>
                <p className="text-lg text-gray-300 mb-8">
                  Connect with our experts to discuss your precious metals trading needs<br/>or inquire about our services.
                </p>
              </div>
              <div className="md:w-auto relative ">
                <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 p-1 rounded-lg shadow-2xl">
                  <img src={contact} alt="Global contact center" className="rounded-lg h-96" />
                </div>
                <div className="absolute -bottom-8 -left-8 bg-white text-black p-4 rounded-lg shadow-lg">
                  <div className="flex items-center gap-2">
                    <Globe className="text-yellow-600" />
                    <span className="font-bold">Global Network</span>
                  </div>
                </div>
                <div className="absolute -top-8 -right-8 bg-white text-black p-4 rounded-lg shadow-lg">
                  <div className="flex items-center gap-2">
                    <Clock className="text-yellow-600" />
                    <span className="font-bold">24/7 Support</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        {/* Main Contact Information */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Global Headquarters */}
              <div className=" p-6 hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                  <MapPin className="text-yellow-600" size={24} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Global Headquarters</h3>
                <div className="space-y-2 text-center">
                  <p className="text-gray-700"> Australia </p>
                  
                </div>
              </div>
              
              {/* Phone Contact */}
              <div className=" p-6  hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                  <Phone className="text-yellow-600" size={24} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Phone Contact</h3>
                <div className="space-y-2 text-center">
                  <p className="text-gray-700">+61 411243525
                  </p>
                 
                </div>
              </div>
              
              {/* Email Contact */}
              <div className="p-6  hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                  <Mail className="text-yellow-600" size={24} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Email Contact</h3>
                <div className="space-y-2 text-center">
                  <p className="text-gray-700">info@pvgimportexport.com.au</p>
                 
                </div>
              </div>
            </div>
          </div>
        </section>
        
        
       
       
        
        {/* Map Section */}
        {/* <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Find Us</h2>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Our offices are strategically located in prime business districts for convenient access.
              </p>
            </div>
            
            <div className="bg-white p-1 rounded-lg shadow-lg">
              <img src="/api/placeholder/1200/500" alt="Global office locations map" className="w-full rounded-lg" />
            </div>
            
            <div className="mt-8 text-center">
              <p className="text-gray-600 mb-4">
                Contact our nearest office to schedule an in-person meeting with our precious metals experts.
              </p>
            </div>
          </div>
        </section> */}
        
        {/* FAQ Section */}
        {/* <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Quick answers to common inquiries about contacting and working with Noble Metals.
              </p>
            </div>
            
            <div className="max-w-3xl mx-auto space-y-6">
              <div className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                <h3 className="text-lg font-bold text-gray-900 mb-2">How quickly can I expect a response to my inquiry?</h3>
                <p className="text-gray-600">
                  We aim to respond to all inquiries within 24 hours during business days. For urgent trading matters, our 24/7 trading desk is available to assist immediately.
                </p>
              </div>
              
              <div className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                <h3 className="text-lg font-bold text-gray-900 mb-2">Do I need to schedule an appointment to visit your offices?</h3>
                <p className="text-gray-600">
                  Yes, we recommend scheduling an appointment in advance to ensure the appropriate specialists are available to meet with you and provide the most relevant assistance.
                </p>
              </div>
              
              <div className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                <h3 className="text-lg font-bold text-gray-900 mb-2">What information should I prepare before contacting Noble Metals?</h3>
                <p className="text-gray-600">
                  To help us serve you better, please have details about your trading requirements, including metal type, quantity, preferred delivery location, and timeline before contacting us.
                </p>
              </div>
              
              <div className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                <h3 className="text-lg font-bold text-gray-900 mb-2">Do you offer virtual consultations?</h3>
                <p className="text-gray-600">
                  Yes, we offer secure video conferencing consultations for clients unable to visit our offices in person. Please contact your nearest regional office to arrange a virtual meeting.
                </p>
              </div>
            </div>
          </div>
        </section> */}
        
        {/* CTA Section */}
        {/* <section className="py-16 bg-gradient-to-r from-yellow-500 to-yellow-600 text-white">
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row items-center justify-between">
              <div className="mb-8 md:mb-0 md:w-2/3">
                <h2 className="text-3xl font-bold mb-4">Ready to Get Started?</h2>
                <p className="text-yellow-100 max-w-xl">
                  Our team of precious metals experts is ready to assist with your trading needs. Contact us today to discuss how we can help you achieve your objectives.
                </p>
              </div>
              <div>
                <button className="bg-white text-yellow-600 hover:bg-gray-100 font-bold py-3 px-6 rounded shadow-lg transition-colors">
                  Contact Us Now
                </button>
              </div>
            </div>
          </div>
        </section> */}
        <Footer />
      </div>
    </>
  );
};

export default ContactUs;